<!-- <div *ngIf="(topCollectionsById$ |async) as topCollectionsById">
    <pre>
        {{topCollectionsById | json}}
    </pre>
</div> -->

<!-- product section start -->
<section class="section-b-space" *ngIf="(usaProduct$ |async) as topCollectionsById">
    <div class="container">
        <div class="row">
            <div class="col-12 product-related">
                <h2>{{'Related Products'|translate}}</h2>
            </div>
        </div>
        <div class="row search-product">
            <div class="col-xl-2 col-md-4 col-sm-6" *ngFor="let product of topCollectionsById.tags">
                <div class="product-box" style="margin-top: 25px;">
                    <!-- <pre>
                    {{product|json}}
                   </pre> -->
                    <app-product-box-one [product]="product" [currency]="productService?.Currency" [cartModal]="true">
                    </app-product-box-one>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- product section end -->